import React from 'react';

export default React.memo(function PageTitleLayout({ title, className = '', classNameTitle = '', children }) {
  return (
    <div className={`text-center ${className}`}>
      <h1 className={`text-white text-6xl md:text-[82px] leading-none font-medium whitespace-pre-line select-none ${classNameTitle}`}>{title}</h1>
      {children}
    </div>
  );
});
